<template>
  <select v-model="$i18n.locale" class="select-input mr-2" @change="onChange($event)">
    <option v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang.type"> {{ lang.name }} {{ lang.flag }} </option>
  </select>
</template>

<script>
export default {
  name: 'SelectLang',
  data() {
    return {
      langs: [
        { type: 'en', name: 'English', flag: '🇬🇧' },
        { type: 'fr', name: 'Français', flag: '🇫🇷' },
        { type: 'es', name: 'Español', flag: '🇪🇸' },
        { type: 'pl', name: 'Polskie', flag: '🇵🇱' },
        { type: 'de', name: 'Deutsch', flag: '🇩🇪' },
        { type: 'it', name: 'Italien', flag: '🇮🇹' },
        { type: 'nl', name: 'Dutch', flag: '🇳🇱' },
        { type: 'pt', name: 'Português', flag: '🇵🇹' },
        { type: 'sv', name: 'Svenska', flag: '🇸🇪' },
        { type: 'da', name: 'Dansk', flag: '🇩🇰' }
      ]
    }
  },
  methods: {
    onChange(event) {
      localStorage.setItem('Stampytlang', event.target.value)
    }
  }
}
</script>

<style lang="sass" scoped>
.select-input
  font-weight: 500
  cursor: pointer
</style>
